import Vue from 'vue'
import VueRouter from 'vue-router'
import home from '../pages/Home.vue'
import platform from '../pages/Platform.vue'
import cases from '../pages/Cases.vue'
import product from '../pages/Product.vue'
import sdk from '../pages/Sdk.vue'
import news from '../pages/News.vue'
import newsDetail from '../pages/NewsDetail.vue'
Vue.use(VueRouter)

// 3. 配置路由规则数组
const routes = [
	{ 
	        path: '/',
	     redirect:'/home'
	    },
	{
		path: '/home',
		component: home
	},
	{
		path: '/platform',
		component: platform
	},
	{
		path: '/cases',
		component: cases
	},
	{
		path: '/product',
		component: product
	},
	{
		path: '/sdk',
		component: sdk
	},
	{
		path: '/news',
		component: news
	},
	{
		path: '/newsDetail/:articleId',
		name: 'newsDetail',
		component: newsDetail,
		props: true
	}
]
// 4. 实例化VueRouter
const router =  new VueRouter({
    routes
})
router.afterEach(() => {window.scrollTo(0,0);
})
// 5. 导出路由实例对象router
export default router


// WEBPACK FOOTER //
// ./src/router/index.js